import { AdminNotificationDestinationType as EventDestination } from '../../../../utils/apollo/graphqlSchema';
import { Controller, useFormContext } from 'react-hook-form';
import TickCheckbox from '../../../../components/Checkbox';
import React, { useCallback } from 'react';
import { CheckboxProps } from 'semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox';
import { createColumnHelper } from '@tanstack/react-table';
import { INotificationSettingsForm, INotificationsSettingsRow } from '../types';
import { ColumnMeta } from '@tanstack/table-core';

interface IProps {
  header: string;
  destination: EventDestination;
  meta: ColumnMeta<INotificationsSettingsRow, unknown>;
}

const useDestinationColumn = () => {
  const { control, formState } = useFormContext<INotificationSettingsForm>();
  const columnHelper = createColumnHelper<INotificationsSettingsRow>();
  const destinationColumnAccessor = useCallback(
    ({ destination, header, meta }: IProps) =>
      columnHelper.accessor(`destinations.${destination}`, {
        id: destination,
        header,
        cell: (data) => {
          const event = data.row.original.event;
          const name =
            `notifications.${event}.destinations.${destination}` as const;
          return (
            <Controller
              control={control}
              name={name}
              render={({ field }) => {
                const disabled =
                  !data.row.original.allowed.includes(destination) ||
                  formState.isSubmitting;
                return (
                  <TickCheckbox
                    checked={field.value}
                    onChange={(
                      _e: React.FormEvent<HTMLInputElement>,
                      checkboxProps: CheckboxProps,
                    ) => {
                      field.onChange(checkboxProps.checked);
                    }}
                    disabled={disabled}
                  />
                );
              }}
            />
          );
        },
        meta,
      }),
    [columnHelper, control, formState.isSubmitting],
  );
  return { destinationColumnAccessor };
};

export default useDestinationColumn;
